import { render, staticRenderFns } from "./touss2.vue?vue&type=template&id=8ef6ae2c&scoped=true&"
import script from "./touss2.vue?vue&type=script&lang=js&"
export * from "./touss2.vue?vue&type=script&lang=js&"
import style0 from "./touss2.vue?vue&type=style&index=0&id=8ef6ae2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef6ae2c",
  null
  
)

export default component.exports